<app-menu headerCSS="bg-dark mb-0">
    <h4 class="jobTitle">{{(wizardStore.selectedJob | async)?.title}}</h4>
    <steps-header [(currentStep)]="wizardStore.step"></steps-header>
</app-menu>
<div class="step-container">
    <app-dashboard-employer-post-new-job *ngIf="wizardStore.step === 1"
        (jobSaved)="onJobSaved($event)"></app-dashboard-employer-post-new-job>
    <div *ngIf="wizardStore.step === 2" class="container candidates-list-container">
        <candidates-list [candidates]="candidates" [totalPageCount]="totalPageCount" [showSalary]="true"
            [showBookmark]="false" (candidateSelected)="onCandidateSelected($event)"></candidates-list>
    </div>
    <div *ngIf="wizardStore.step === 3">
        <app-discuss></app-discuss>
    </div>
    <div *ngIf="wizardStore.step === 4">
        <app-hire></app-hire>
    </div>
    <div *ngIf="wizardStore.step === 5">
        <app-close-wizard></app-close-wizard>
    </div>
</div>
<app-footer></app-footer>